import React from "react"
import { useTranslation } from "react-i18next"
import styled from "styled-components"
import { Tooltip } from "react-tooltip"

const WrapIcon = styled.div`
  width: 18px;
  height: 18px;
  padding: 0 2px;
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translate(-50%, -38px);
  border-radius: 50%;
  background-color: ${props => props.theme.color.encryption};
  color: ${props => props.theme.color.area};
`

const EncryptionIcon = () => {
  const { t } = useTranslation("generic")

  return (
    <>
    <WrapIcon data-tooltip-id="encryptionicon_tooltip" data-tooltip-content={t("##.Upload.Encrypted")}>
      <i className="icon-lock" />
    </WrapIcon>
    <Tooltip id="encryptionicon_tooltip" />
    </>
  )
}

export default EncryptionIcon
